import React from 'react';
import { Link } from 'react-router-dom';
import './MarketDetail.css';

const MarketDetail = ({ title, subMarkets, description, image, imageAlt, reverse, buttonLink  }) => {
    const containerClass = `market-detail-container ${reverse ? 'reverse' : ''}`;
  return (
    <section className="market-detail-section">
      <div className={containerClass}>
        {/* Left Column (or Right on reverse): Text Content */}
        <div className="market-detail-text-col">
          <h3>{title}</h3>
          <div className="sub-market-links">
            {subMarkets.join(' | ')}
          </div>
          <p>{description}</p>
          {/* This button now links to the main markets page as an example */}
          <Link to={buttonLink || '/markets'}>
              <button className="explore-more-btn">Explore more</button>
          </Link>
        </div>

        {/* Right Column (or Left on reverse): Image */}
        <div className="market-detail-image-col">
          <img src={image} alt={imageAlt} />
        </div>
      </div>
    </section>
  );
};

export default MarketDetail;